import styled, { css } from 'styled-components';
var List = styled.section.withConfig({
  displayName: "TrolleyItemListstyles__List",
  componentId: "sc-1yks147-0"
})(["padding:20px 15px;border-bottom:1px solid ", ";&:last-child{border-bottom:0;}", ""], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.itemType === 'primary' && css(["padding:10px 15px;margin:0;background:", ";border-bottom:1px solid ", ";+ .add-to-trolley-list{border-top:0;}"], props.theme.color.monochrome.lighter, props.theme.color.monochrome.light);
});
var ItemWrapper = styled.div.withConfig({
  displayName: "TrolleyItemListstyles__ItemWrapper",
  componentId: "sc-1yks147-1"
})(["display:flex;justify-content:space-between;", " ", ""], function (props) {
  return props.isOneChild && css(["justify-content:center;"]);
}, function (props) {
  return css(["@media only screen and (max-width:", "){flex-direction:column;}"], props.theme.size.breakpoint['max-width'].sm);
});
var KeyExclusions = styled.p.withConfig({
  displayName: "TrolleyItemListstyles__KeyExclusions",
  componentId: "sc-1yks147-2"
})(["&&{margin-top:0.625rem;margin-bottom:0;}"]);
var CareProviderContainer = styled.div.withConfig({
  displayName: "TrolleyItemListstyles__CareProviderContainer",
  componentId: "sc-1yks147-3"
})(["display:flex;flex-direction:column;align-items:center;border-top:1px solid ", ";margin-top:10px;padding-top:10px;"], function (props) {
  return props.theme.color.monochrome.light;
});
var DGLogoContainer = styled.div.withConfig({
  displayName: "TrolleyItemListstyles__DGLogoContainer",
  componentId: "sc-1yks147-4"
})(["font-size:", ";line-height:normal;flex:1;display:flex;justify-content:center;align-items:center;margin-top:10px;"], function (props) {
  return props.theme.font.size.caption;
});
var TrustPilotLogoContainer = styled.div.withConfig({
  displayName: "TrolleyItemListstyles__TrustPilotLogoContainer",
  componentId: "sc-1yks147-5"
})(["flex:1;display:flex;flex-direction:column;justify-content:center;align-items:center;margin-top:10px;"]);
var TrustPilotRating = styled.p.withConfig({
  displayName: "TrolleyItemListstyles__TrustPilotRating",
  componentId: "sc-1yks147-6"
})(["&&{font-size:", ";line-height:normal;margin:10px;text-align:center;}"], function (props) {
  return props.theme.font.size.caption;
});
export { TrustPilotRating, List, ItemWrapper, KeyExclusions, CareProviderContainer, DGLogoContainer, TrustPilotLogoContainer };